import { withStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme';

export default withStyles((theme) => ({
  root: {
    background: 'transparent',
    borderRadius: '4px',
    minWidth: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0 0.5rem',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      '&:not(.disable-responsive)': {
        display: 'block',
      },
    },
  },
  tHead: {
    color: variables.palette.primary.light,
    fontSize: theme.typography.fontSize,
    fontWeight: 400,
  },
  tBody: {
    color: variables.palette.primary.light,
    fontSize: theme.typography.fontSize,
    fontWeight: 400,
  },
  th: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    fontSize: theme.typography.fontSize,
    textAlign: 'left',
    lineHeight: 1.3,
    ['&.numeric' as any]: {
      textAlign: 'right',
    },
    ['&:first-child' as any]: {
      borderTopLeftRadius: 6,
      borderBottomLeftRadius: 6,
      paddingLeft: theme.spacing(2),
      ['&.status ' as any]: {
        paddingLeft: 0,
        paddingRight: 16,
      },
    },
    ['&:last-child' as any]: {
      borderTopRightRadius: 6,
      borderBottomRightRadius: 6,
      paddingRight: theme.spacing(2),
    },
    ['&.ordering' as any]: {
      cursor: 'pointer',
    },
  },
  td: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    fontSize: 13,
    position: 'relative',
    lineHeight: 1.3,
    color: variables.palette.primary.light,
    background: theme.palette.grey[100],
    minHeight: theme.spacing(2) * 6,
    ['&.numeric' as any]: {
      textAlign: 'right',
    },
    ['&:first-child' as any]: {
      borderTopLeftRadius: 6,
      borderBottomLeftRadius: 6,
      paddingLeft: theme.spacing(2),
      ['&.status ' as any]: {
        paddingLeft: 0,
        paddingRight: 16,
      },
    },
    ['&:last-child' as any]: {
      borderTopRightRadius: 6,
      borderBottomRightRadius: 6,
      paddingRight: theme.spacing(2),
    },
  },
  tdCard: {
    fontSize: 13,
    position: 'relative',
    lineHeight: 1.3,
    padding: theme.spacing(2),
    color: variables.palette.primary.light,
    background: theme.palette.grey[100],
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
    },

    ['&.action' as any]: {
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      },
    },
  },
  tdCardRow: {
    width: '100%',
    borderRadius: 6,
    overflow: 'hidden',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    background: theme.palette.grey[100],
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  tRow: {
    width: '100%',
    borderRadius: 6,
    overflow: 'hidden',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    background: theme.palette.grey[100],
    minHeight: theme.spacing(2) * 6,
  },
}));
